import { StateProxy } from "./state.interface";
import { StateSignal } from "./state-signal";
import { ViewState } from "../../../core";

/**
 * Creates a state object from the given initial state value. This wraps the
 * State itself in a Proxy to improve DX in Angular templates.
 *
 * @param state Initial value.
 */
export function createState<T extends ViewState>(state: T): StateProxy<T> {
  // Simulate access to the state value as if it was a property of the state
  // object. So intstead of `state.$value.property` we can write
  // `state.property`.
  return new Proxy(new StateSignal(state), {
    get: (target, prop, receiver) => {
      const value = target.$value;

      // Intercept property access and redirect it to `$value`
      if (Reflect.has(value, prop)) {
        return Reflect.get(value, prop, receiver);
      }

      // Fallback to the original behavior for properties not found in `$value`
      return Reflect.get(target, prop, receiver);
    },
  }) as unknown as StateProxy<T>;
}
